import Index from '@/views/exhibitor/brand/Index.vue';
import Top from '@/views/exhibitor/brand/Top.vue';
import New from '@/views/exhibitor/brand/New.vue';
import Edit from '@/views/exhibitor/brand/Edit.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'brand',
    component: Index,
    children: [
      {
        name: 'exhibitor-brand-top',
        path: '',
        component: Top,
        meta: {
          title: 'ブランド詳細',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      {
        name: 'exhibitor-brand-new',
        path: 'new',
        component: New,
        meta: {
          title: '新規作成',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      {
        name: 'exhibitor-brand-edit',
        path: 'edit',
        component: Edit,
        meta: {
          title: '編集',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
    ],
  },
];

export default {
  routes,
};
